import type { FaireProductEntity } from "../../entity_types/product";

export const p_mvehe7s5gp: FaireProductEntity = {
  token: "p_mvehe7s5gp",
  type: "product",
  name: "Ladybug Little Notes® Duo Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/1d36bdc07c673f5a5ce4d6edee4352b33512e530eacc36c5929922936486128a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/af0adfea8abcdad1ffea880fd2651b02b1f101efee2fcffa65c03d09f36275e9.jpeg",
    "https://cdn.faire.com/fastly/2dae96690bdc4f13e10b5497a769d18aa600c081e1d9daa051c48d86dbe96223.jpeg",
    "https://cdn.faire.com/fastly/355f100e210081536b19f3d88be09bcaa46fd6a9ff6f894142fb7184ed814692.jpeg",
    "https://cdn.faire.com/fastly/c36f31feb8fe7dc16297981014287be1616181eb87ed2c311e1ba2ddc2a3575d.jpeg",
  ],
  priceDollars: 6,
  description:
    "The cutest little duos you ever did see. Set of 10 Little Notes®and 10 Little Note Envelopes. These corresponding Little Notes® and printed envelopes take the surprise and delight of Little Notes to the next level - so up your gift tag/secret note/barista tip game! Please note: These envelopes are so adorably tiny that they're too small for the postal service, so hand-deliver only!",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:32.365Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
